<template>
    <div class="bar-chart-container">
        <highcharts
            v-if="chartOptions"
            :options="chartOptions"
            class="w-full h-full"
        ></highcharts>
        <div v-else class="flex items-center justify-center h-full text-gray-500">
            <p>No data available</p>
        </div>
    </div>
</template>

<script>
import { Chart } from "highcharts-vue";

export default {
    name: "BarChart",
    components: {
        highcharts: Chart
    },
    props: {
        series: {
            type: Array,
            required: true
        },
        categories: {
            type: Array,
            default: () => []
        },
        height: {
            type: Number,
            default: 350
        },
        title: {
            type: String,
            default: ""
        },
        yAxisTitle: {
            type: String,
            default: ""
        }
    },
    computed: {
        chartOptions() {
            if (!this.series || this.series.length === 0) return null;

            return {
                chart: {
                    type: "column",
                    backgroundColor: "transparent",
                    height: this.height,
                    style: {
                        fontFamily: "inherit"
                    }
                },
                title: {
                    text: this.title || null
                },
                credits: {
                    enabled: false
                },
                accessibility: {
                    enabled: true,
                    point: {
                        valueDescriptionFormat: "{xDescription}{separator}{value}"
                    }
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    categories: this.categories,
                    gridLineWidth: 0,
                    lineColor: "#E5E7EB",
                    lineWidth: 1,
                    tickColor: "#E5E7EB",
                    tickWidth: 1,
                    tickLength: 5,
                    labels: {
                        style: {
                            color: "#6B7280",
                            fontSize: "12px",
                            fontWeight: "400"
                        },
                        y: 20
                    },
                    crosshair: {
                        width: 1,
                        color: "#E5E7EB",
                        dashStyle: "Dash"
                    }
                },
                yAxis: {
                    title: {
                        text: this.yAxisTitle || null
                    },
                    gridLineColor: "#F3F4F6",
                    gridLineWidth: 1,
                    gridLineDashStyle: "Solid",
                    labels: {
                        style: {
                            color: "#6B7280",
                            fontSize: "12px",
                            fontWeight: "400"
                        },
                        x: -10
                    },
                    lineWidth: 0,
                    minorGridLineWidth: 0,
                    allowDecimals: false
                },
                tooltip: {
                    backgroundColor: "rgba(55, 65, 81, 0.97)",
                    borderColor: "#374151",
                    borderRadius: 8,
                    borderWidth: 0,
                    shadow: {
                        color: "rgba(0, 0, 0, 0.1)",
                        offsetX: 0,
                        offsetY: 2,
                        width: 8,
                        opacity: 0.15
                    },
                    style: {
                        color: "#ffffff",
                        fontSize: "12px",
                        fontWeight: "400"
                    },
                    padding: 12,
                    useHTML: true,
                    headerFormat: "<div style=\"font-size: 11px; color: #D1D5DB; margin-bottom: 6px;\">{point.key}</div>",
                    pointFormat: "<div style=\"display: flex; align-items: center; margin-bottom: 4px;\">" +
                                "<span style=\"color:{point.color}; font-size: 16px; margin-right: 6px;\">●</span>" +
                                "<span style=\"font-weight: 500;\">{series.name}:</span>" +
                                "<span style=\"margin-left: 8px; font-weight: 600;\">{point.y}</span>" +
                                "</div>",
                    footerFormat: "</div>"
                },
                plotOptions: {
                    column: {
                        borderRadius: 4,
                        borderWidth: 0,
                        colorByPoint: true,
                        colors: ["#8979FF", "#FF928A", "#3CC3DF", "#FFAE4C", "#0398DC", "#10B981", "#8B5CF6", "#F43F5E"],
                        dataLabels: {
                            enabled: false
                        }
                    },
                    series: {
                        animation: {
                            duration: 1200,
                            easing: "easeOutQuart"
                        }
                    }
                },
                series: this.series
            };
        }
    }
};
</script>

<style scoped>
.bar-chart-container {
    width: 100%;
    height: 100%;
}
</style>
